export const EMPTY_PRIME_PAYER_OUTSTANDING_ROW = {
  payer_name: '',
  payer_sector: '',
  oustanding_aed: '',
  oustanding_pct: '',
  weighted_adtp: ''
};

export const PRIME_PAYER_OUTSTANDING_TABLE_COLUMNS = [
  {
    key: 'payer_name',
    label: 'Prime Payer Name',
    placeholder: 'Payer name...',
    width: '34%'
  },
  {
    key: 'payer_sector',
    label: 'Industry Sector',
    placeholder: 'Industry sector...',
    width: '22%'
  },
  {
    key: 'oustanding_aed',
    label: 'AR Outstanding (AED)',
    placeholder: '0',
    width: '14%',
    align: 'right',
    numeric: true
  },
  {
    key: 'oustanding_pct',
    label: '% of Total AR',
    placeholder: '%',
    width: '14%',
    align: 'right',
    numeric: true
  },
  {
    key: 'weighted_adtp',
    label: 'Weighted ADTP',
    placeholder: 'Days',
    width: '14%',
    align: 'right',
    numeric: true
  }
];

export const EMPTY_PRIME_PAYER_SALES_ROW = {
  payer_name: '',
  payer_sector: '',
  sales_aed: '',
  sales_pct: '',
  parent: ''
};

export const PRIME_PAYER_SALES_TABLE_COLUMNS = [
  {
    key: 'payer_name',
    label: 'Prime Payer Name',
    placeholder: 'Payer name...',
    width: '30%'
  },
  {
    key: 'payer_sector',
    label: 'Industry Sector',
    placeholder: 'Industry sector...',
    width: '18%'
  },
  {
    key: 'sales_aed',
    label: 'Sales Contribution (AED)',
    placeholder: '0',
    width: '14%',
    align: 'right',
    numeric: true
  },
  {
    key: 'sales_pct',
    label: '% Sales Contribution (AED)',
    placeholder: '%',
    width: '12%',
    align: 'right',
    numeric: true
  },
  {
    key: 'parent',
    label: 'Associated Parent',
    placeholder: 'Parent company...',
    width: '24%'
  }
];

export const EMPTY_APPROVED_PAYER_SALES_ROW = {
  payer_name: '',
  payer_sector: '',
  sales_aed: '',
  sales_pct: '',
  parent: ''
};

export const APPROVED_PAYER_SALES_TABLE_COLUMNS = [
  {
    key: 'payer_name',
    label: 'Approved Payer Name',
    placeholder: 'Payer name...',
    width: '30%'
  },
  {
    key: 'payer_sector',
    label: 'Industry Sector',
    placeholder: 'Industry sector...',
    width: '18%'
  },
  {
    key: 'sales_aed',
    label: 'Sales Contribution (AED)',
    placeholder: '0',
    width: '14%',
    align: 'right',
    numeric: true
  },
  {
    key: 'sales_pct',
    label: '% Sales Contribution (AED)',
    placeholder: '%',
    width: '12%',
    align: 'right',
    numeric: true
  },
  {
    key: 'parent',
    label: 'Associated Parent',
    placeholder: 'Parent company...',
    width: '24%'
  }
];

export const EMPTY_PRIME_PAYER_AGING_ROW = {
  payer_name: '',
  '0_30_days': '',
  '31_60_days': '',
  '61_90_days': '',
  '>90_days': '',
  pcr: ''
};

export const EMPTY_APPROVED_PAYER_OUTSTANDING_ROW = {
  payer_name: '',
  payer_sector: '',
  oustanding_aed: '',
  oustanding_pct: '',
  weighted_adtp: ''
};

export const APPROVED_PAYER_OUTSTANDING_TABLE_COLUMNS = [
  {
    key: 'payer_name',
    label: 'Approved Payer Name',
    placeholder: 'Payer name...',
    width: '34%'
  },
  {
    key: 'payer_sector',
    label: 'Industry Sector',
    placeholder: 'Industry sector...',
    width: '22%'
  },
  {
    key: 'oustanding_aed',
    label: 'Current AR Outstanding (AED)',
    placeholder: '0',
    width: '14%',
    align: 'right',
    numeric: true
  },
  {
    key: 'oustanding_pct',
    label: '% of Total AR',
    placeholder: '%',
    width: '14%',
    align: 'right',
    numeric: true
  },
  {
    key: 'weighted_adtp',
    label: 'ADTP (days from due date - last 12 months)',
    placeholder: 'Days',
    width: '16%',
    align: 'right',
    numeric: true
  }
];

export const PRIME_PAYER_AGING_TABLE_COLUMNS = [
  {
    key: 'payer_name',
    label: 'Prime Payer Names',
    placeholder: 'Payer name...',
    width: '35%'
  },
  {
    key: '0_30_days',
    label: '0 - 30 Days',
    placeholder: '%',
    width: '13%',
    align: 'right',
    numeric: true
  },
  {
    key: '31_60_days',
    label: '31 - 60 Days',
    placeholder: '%',
    width: '13%',
    align: 'right',
    numeric: true
  },
  {
    key: '61_90_days',
    label: '61 - 90 days',
    placeholder: '%',
    width: '13%',
    align: 'right',
    numeric: true
  },
  {
    key: '>90_days',
    label: '> 90 days',
    placeholder: '%',
    width: '13%',
    align: 'right',
    numeric: true
  },
  {
    key: 'pcr',
    label: 'PCR',
    placeholder: '%',
    width: '13%',
    align: 'right',
    numeric: true
  }
];

export const EMPTY_APPROVED_PAYER_AGING_ROW = {
  payer_name: '',
  '0_30_days': '',
  '31_60_days': '',
  '61_90_days': '',
  '>90_days': '',
  pcr: ''
};

export const APPROVED_PAYER_AGING_TABLE_COLUMNS = [
  {
    key: 'payer_name',
    label: 'Approved Payer Names',
    placeholder: 'Payer name...',
    width: '35%'
  },
  {
    key: '0_30_days',
    label: '0 - 30 Days',
    placeholder: '%',
    width: '13%',
    align: 'right',
    numeric: true
  },
  {
    key: '31_60_days',
    label: '31 - 60 Days',
    placeholder: '%',
    width: '13%',
    align: 'right',
    numeric: true
  },
  {
    key: '61_90_days',
    label: '61 - 90 days',
    placeholder: '%',
    width: '13%',
    align: 'right',
    numeric: true
  },
  {
    key: '>90_days',
    label: '> 90 days',
    placeholder: '%',
    width: '13%',
    align: 'right',
    numeric: true
  },
  {
    key: 'pcr',
    label: 'PCR',
    placeholder: '%',
    width: '13%',
    align: 'right',
    numeric: true
  }
];
